import {CheckCircle, Cancel, Edit, MoreVert, RunCircle} from "@mui/icons-material";
import {IconButton, Menu, MenuItem, Typography} from "@mui/material";
import React from "react";
import {Black, Blue3, Green3, Grey17, Grey6, Red3} from "../../theme/styles";
import css_self from "../Navigation/css/NavBar.module.scss";
import {EnlilTable} from "../EnlilTable";
import {withAppContext} from "../../util/withAppContext";
import withNavigate from "../../util/useNavigate";
import withBreakpoint from "../../util/withBreakpoint";
import css_buttons from "../Common/css/CCButton.module.scss";
import moment from "moment-timezone";

class ETLJobExecutionTable extends EnlilTable {

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    getCellRenderer(name) {
        if (name === "Action Cell") {
            return this.renderActionCell;
        } else if (name === "Status Cell") {
            return this.renderStatusCell;
        } else if (name === "Difference Cell") {
            return this.renderDifferenceCell;
        }
        return super.getCellRenderer(name);
    };

    handleMenuClick(identifier) {
        if (identifier === "New Execution") {
            this.setState({renderTarget: "New Execution"});
        } else if (identifier === "Edit Execution") {
            this.setState({renderTarget: "Edit Execution"});
        }
        super.handleMenuClick(identifier);
    }

    renderExtension() {
    };

    onCancelHandler = () => {
        this.setState({renderTarget: null});
    };

    renderStatusCell = (___, params, __, _) => {
        let buffer;
        let color;

        if (this.state.fetchBackgroundOperation) {
            color = "#7B8291"
            buffer = this.state.previousBuffer
        } else {
            buffer = this.state.buffer
        }

        if (params.row.id > this.state.buffer.length - 1) return;

        let content = buffer[params.row.id].get(params.field)

        if (content === "Running") {
            color = Blue3;
        }
        if (content === "Succeeded") {
            color = Green3;
        }
        if (content === "Failed") {
            color = Red3;
        }

        if (this.state.fetchBackgroundOperation) {
            color = "#7B8291"
        }

        return (
            <div style={{display: "flex", flexDirection: "row", justifyContent: "left", alignContent: "center", height: "100%"}}>
                {content === "Succeeded" ? <CheckCircle sx={{color: color, width: "25px", height: "25px", margin: "auto 0 auto 0"}} /> : null}
                {content === "Failed" ? <Cancel sx={{color: color, width: "25px", height: "25px", margin: "auto 0 auto 0"}} /> : null}
                {content === "Running" ? <RunCircle sx={{color: color, width: "25px", height: "25px", margin: "auto 0 auto 0"}} /> : null}
                <Typography style={{fontSize: "14px", margin: "auto 0 auto 5px", color: this.state.fetchBackgroundOperation ? "#7B8291" : Black}}>{content}</Typography>
            </div>
        )
    };

    renderDifferenceCell = (___, params, __, _) => {
        let buffer;
        let color;

        if (this.state.fetchBackgroundOperation) {
            color = "#7B8291"
            buffer = this.state.previousBuffer
        } else {
            color = Black
            buffer = this.state.buffer
        }

        if (params.row.id > this.state.buffer.length - 1) return;

        let content;
        let startedDatetime = moment.utc(buffer[params.row.id].get("StartedDatetime"))
        if (buffer[params.row.id].get("StoppedDatetime") !== null) {
            let stoppedDatetime = moment.utc(buffer[params.row.id].get("StoppedDatetime"))
            const diffInMillis = stoppedDatetime.diff(startedDatetime);
            const duration = moment.duration(diffInMillis);
            let hours = duration.hours();
            let minutes = duration.minutes();
            let seconds = duration.seconds();

            if (hours > 0) {
                content = hours + " hours " + minutes + " minutes " + seconds + " seconds";
            } else if (minutes > 0) {
                content = minutes + " minutes " + seconds + " seconds";
            } else {
                content = seconds + " seconds";
            }
        }
        if (params.row.id > buffer.length - 1) return;

        return (
            <div style={{display: "flex", flexDirection: "row", justifyContent: "left", alignContent: "center", height: "100%"}}>
                <Typography style={{fontSize: "14px", margin: "auto 0 auto 5px", color: color}}>{content}</Typography>
            </div>
        )
    };
    renderActionCell = (instance, params, columnId, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        return (
            <div style={{width: "50px", backgroundColor: "#FFFFFF", marginLeft: "-9px", paddingLeft: "8px", marginRight: "auto", marginTop: "auto", marginBottom: "auto", height: "100%"}}>
                <IconButton className={css_buttons.blueIconButton} onClick={(event) => {
                    if (this.state.tableActionMenuTarget === null) {
                        this.setState({tableActionMenuTarget: event.currentTarget});
                    } else {
                        this.setState({tableActionMenuTarget: null});
                    }
                }}>
                    <MoreVert />
                </IconButton>
                <Menu anchorEl={this.state.tableActionMenuTarget}
                      anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                      transformOrigin={{vertical: -10, horizontal: "center"}}
                      open={this.state.tableActionMenuTarget !== null && this.state.tableActionMenuTarget !== undefined}
                      onClose={() => this.setState({tableActionMenuTarget: null})}
                      TransitionProps={{
                          onExited: () => this.setState({tableActionMenuTarget: null}),
                      }}
                      MenuListProps={{
                          ...{"data-cc-component": "NavMenu"},
                          disablePadding: true,
                          style: {"minWidth": "200px"},
                      }}
                      PaperProps={{
                          elevation: 2,
                      }}
                >
                    <MenuItem divider key={"1"} className={css_self.Standard} onClick={() => {
                        this.setState({tableActionMenuTarget: null, renderTarget: "Edit Position"});
                    }}>
                        <Edit style={{color: Grey6}} />
                        <Typography style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>Edit Position</Typography>
                    </MenuItem>
                </Menu>
            </div>
        );
    };
}

export default withNavigate(withAppContext(withBreakpoint(ETLJobExecutionTable)));